var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-config-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("general.logo"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "logo" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c("div", { staticClass: "admin-config-panel__inner" }, [
            _c("div", { staticClass: "row admin-config-forms-row" }, [
              _c("div", { staticClass: "col-12 col-lg-6" }, [
                _c(
                  "section",
                  {
                    staticClass: "admin-config-section",
                    attrs: {
                      "aria-label": _vm.trans("general.logo_type", {
                        type: _vm.trans("general.sidebar"),
                      }),
                    },
                  },
                  [
                    _c("h4", { staticClass: "admin-config-section__title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.trans("general.logo_type", {
                            type: _vm.trans("general.sidebar"),
                          })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "admin-config-section__description" },
                      [
                        _vm._v(
                          "Used in the admin navigation and compact brand placements."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("upload-image", {
                      attrs: {
                        id: "sidebar_logo",
                        "upload-path": "/configuration/logo/sidebar",
                        "remove-path": "/configuration/logo/sidebar/remove",
                        "image-source": _vm.logo.sidebar,
                      },
                      on: {
                        uploaded: _vm.updateSidebarLogo,
                        removed: _vm.updateSidebarLogo,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-6" }, [
                _c(
                  "section",
                  {
                    staticClass: "admin-config-section",
                    attrs: {
                      "aria-label": _vm.trans("general.logo_type", {
                        type: _vm.trans("general.main"),
                      }),
                    },
                  },
                  [
                    _c("h4", { staticClass: "admin-config-section__title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.trans("general.logo_type", {
                            type: _vm.trans("general.main"),
                          })
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "admin-config-section__description" },
                      [
                        _vm._v(
                          "Used wherever the full company mark is displayed."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("upload-image", {
                      attrs: {
                        id: "logo",
                        "upload-path": "/configuration/logo/main",
                        "remove-path": "/configuration/logo/main/remove",
                        "image-source": _vm.logo.main,
                      },
                      on: {
                        uploaded: _vm.updateMainLogo,
                        removed: _vm.updateMainLogo,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Update the brand marks shown in the admin shell and public-facing surfaces."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }